module.exports = __webpack_public_path__ + "static/img/arrowBack.964571a2.svg";